// test655
(655 && 0);
